import * as BABYLON from "babylonjs"
import * as GUI from "babylonjs-gui"
import { radioButtonGroups } from "./RadioButtonManager"

export class RadioButton {
	static create(
		scene: BABYLON.Scene,
		id: string,
		position: [number, number, number],
		imageSize: [number, number], // [width, height] in pixels
		imageUrl: string,
		group: string, // Group name to link radio buttons
		colour: string,
		onCheckChanged: (isChecked: boolean) => void,
		isChecked: boolean = false,
		visibility: boolean = true,
		grabbable: boolean = false,
		parentID?: string // Optional parent ID
	): void {
		// Create a plane to act as the base for the image radio button
		const plane = BABYLON.MeshBuilder.CreatePlane(
			id,
			{ width: imageSize[0], height: imageSize[1] }, // Converting pixels to world units, adjust as necessary
			scene
		)
		plane.position = new BABYLON.Vector3(position[0], position[1], position[2])

		// Create an advanced texture for this plane
		const advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(
			plane,
			512,
			512
		)

		const rectangle = new GUI.Rectangle()
		rectangle.width = "100%"
		rectangle.height = "100%"
		rectangle.cornerRadius = 20
		rectangle.thickness = 0
		advancedTexture.addControl(rectangle)

		// Create an image control for the radio button
		const image = new GUI.Image(`UI_${id}_image`, imageUrl)
		image.width = "100%"
		image.height = "100%"
		image.stretch = GUI.Image.STRETCH_FILL
		image.isPointerBlocker = false

		// Create the radio button control
		const radioButton = new GUI.RadioButton(`UI_${id}_radioButton`)
		radioButton.width = "100%" // Set as needed
		radioButton.height = "100%" // Set as needed
		radioButton.isChecked = isChecked
		if (!radioButtonGroups[group]) {
			radioButtonGroups[group] = []
		}
		radioButtonGroups[group].push(radioButton)

		radioButton.onIsCheckedChangedObservable.add((state) => {
			if (state) {
				const groupName = radioButton.group // Assuming you have a way to get the current radio button's group
				const radioButtonsInGroup = radioButtonGroups[groupName]
				radioButtonsInGroup.forEach((rb) => {
					if (rb !== radioButton) {
						// Prevent unchecking the currently selected radio button
						rb.isChecked = false
					}
				})
				rectangle.thickness = 30
				rectangle.color = colour
			} else {
				rectangle.thickness = 0
			}
			onCheckChanged(state)
		})
		radioButton.onPointerEnterObservable.add(() => {
			if (rectangle.thickness == 0) {
				rectangle.thickness = 30
				rectangle.color = "black"
			}
		})
		radioButton.onPointerOutObservable.add(() => {
			if (rectangle.color == "black") rectangle.thickness = 0
		})

		radioButton.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT
		radioButton.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP
		radioButton.group = group
		radioButton.isPointerBlocker = true
		radioButton.alpha = 0

		// Add the controls to the advanced texture
		rectangle.addControl(image) // Add image first to appear below
		rectangle.addControl(radioButton) // Add radio button over the image

		// Setting the parent if parentID is provided
		if (parentID) {
			const parentMesh = scene.getMeshByID(parentID) as BABYLON.Mesh
			if (parentMesh) {
				plane.parent = parentMesh
			}
		}
		if (grabbable) {
			// Instead of PointerDragBehavior, use SixDofDragBehavior for 3D dragging
			const dragBehavior = new BABYLON.SixDofDragBehavior()
			plane.addBehavior(dragBehavior)

			dragBehavior.onDragStartObservable.add(() => {
				console.log("3D dragging started")
			})
			// No onDragObservable here, SixDofDragBehavior does not provide continuous updates like PointerDragBehavior
			dragBehavior.onDragEndObservable.add(() => {
				console.log("3D dragging ended")
			})
		}

		plane.isVisible = visibility
		plane.renderingGroupId = 2
	}
}
